type NumberedListTone = "positive" | "warning" | "neutral";

export interface NumberedListItem {
  label: string;
  detail?: string;
}

interface NumberedListCardProps {
  eyebrow?: string;
  title: string;
  description?: string;
  items: Array<string | NumberedListItem>;
  tone?: NumberedListTone;
}

const toneMap: Record<NumberedListTone, string> = {
  positive: "#77f4c3",
  warning: "#ffcf7d",
  neutral: "#7fd0ff"
};

function normalizeItem(item: string | NumberedListItem): NumberedListItem {
  return typeof item === "string" ? { label: item } : item;
}

export function NumberedListCard({
  eyebrow,
  title,
  description,
  items,
  tone = "neutral"
}: NumberedListCardProps) {
  const accent = toneMap[tone];

  return (
    <section
      style={{
        borderRadius: "24px",
        padding: "24px",
        background: "linear-gradient(180deg, rgba(9, 14, 26, 0.92), rgba(7, 11, 21, 0.82))",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 18px 42px rgba(3, 8, 20, 0.24)"
      }}
    >
      <div className="stack-md">
        <div className="stack-xs">
          {eyebrow ? <span className="card-eyebrow">{eyebrow}</span> : null}
          <h3 className="card-title">{title}</h3>
          {description ? <p className="card-copy">{description}</p> : null}
        </div>
        <div style={{ display: "grid", gap: "14px" }}>
          {items.map((rawItem, index) => {
            const item = normalizeItem(rawItem);

            return (
              <div
                key={`${item.label}-${index}`}
                style={{
                  display: "grid",
                  gridTemplateColumns: "30px minmax(0, 1fr)",
                  gap: "12px",
                  alignItems: "start",
                  paddingTop: index === 0 ? 0 : "14px",
                  borderTop: index === 0 ? "none" : "1px solid rgba(255,255,255,0.06)"
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "30px",
                    height: "30px",
                    borderRadius: "999px",
                    background: `${accent}22`,
                    border: `1px solid ${accent}55`,
                    color: accent,
                    fontSize: "0.8rem",
                    fontWeight: 700
                  }}
                >
                  {index + 1}
                </span>
                <div className="stack-xs">
                  <div style={{ color: "#f4f8ff", lineHeight: 1.45 }}>{item.label}</div>
                  {item.detail ? (
                    <div style={{ color: "rgba(221, 231, 247, 0.76)", lineHeight: 1.5 }}>{item.detail}</div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
